module.exports = __webpack_public_path__ + "img/loading.c5cd7f53.gif";